import { render, staticRenderFns } from "./IdentityBox.vue?vue&type=template&id=777359b5&scoped=true&"
import script from "./IdentityBox.vue?vue&type=script&lang=js&"
export * from "./IdentityBox.vue?vue&type=script&lang=js&"
import style0 from "./IdentityBox.vue?vue&type=style&index=0&id=777359b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777359b5",
  null
  
)

export default component.exports